import { render, staticRenderFns } from "./CreateContactLogin.vue?vue&type=template&id=f2c7f72e&scoped=true&"
import script from "./CreateContactLogin.vue?vue&type=script&lang=js&"
export * from "./CreateContactLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c7f72e",
  null
  
)

export default component.exports